//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux';

//import Components
import {Container, Collapse, Row, Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';

import ArticleInputFormGroup from './Elements/ArticleInputFormGroup';
import QuillEditor from '../../Components/QuillEditor/QuillEditor';
import ArticleDateFormGroup from './Elements/ArticleDateFormGroup';
import ArticleSelectFormGroup from './Elements/ArticleSelectFormGroup';

import * as homepageActions from '../actions/homepageActions';
import * as dateUtils from './Utils/dateUtils';

//import Styles
import './NewArticle.css';

class NewArticle extends Component {
    constructor(props) {

        const today = new Date();
        const dd = today.getDate();
        const mm = today.getMonth()+1; //January is 0!
        const yyyy = today.getFullYear();

        super(props);

        this.state = {
            collapse : false,

            title : '',
            subTitle : '',
            text : '',
            category : 'news',
            date : `${yyyy}/${mm}/${dd}`,
            
            imageCount : 0
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', () => {
            if(this.state.collapse) {
                this.props.onDeleteAddedNewArticle(this.props.id, this.state.imageCount);
            }
        })
    }

    toggleCollapse = () => {
        this.setState(prevState => ({
            collapse : !prevState.collapse,
            title : '',
            subTitle : '',
            category : 'news',
            text : ''
        }))
    }

    handleOnChange= (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }
    handleQuillChange = (value) => {
        this.setState({
            text : value
        })
    }

    setImageCount = (value) => {
        this.setState({
            imageCount : value
        })
    }

    canRegisterArticle = ()=> {
        return (
            this.state.title !== '' &&
            this.state.subTitle !== '' && 
            this.state.text !== '' &&
            dateUtils.validateDate(this.state.date)
        )
    }

    render() {
        const canRegister = this.canRegisterArticle();

        const noticeAdd = (
            <Row>
                <Col>
                    <div
                        className="sub-category-add-btn"
                        onClick={() => {
                            this.props.askCancleEditing(() => {
                                this.props.toggleEditing();
                                this.toggleCollapse();
                                this.props.onStartAddNewArticle();
                            })
                        }}
                    >
                        공지 추가
                    </div>
                </Col>
            </Row>
        );

        return(
            <div>
                {
                    !this.state.collapse && noticeAdd
                }
                <Collapse className="article-add-collapse" isOpen={this.state.collapse}>
                    <Form className="article-form">
                        <ArticleSelectFormGroup
                            label="분류"
                            name="category"
                            value={this.state.categoery}
                            onChange={this.handleOnChange}
                            options={["대영소식", "자료실"]}
                            values={["news", "reference"]}
                        />
                        <ArticleDateFormGroup 
                            label="날짜"
                            type="text"
                            name="date"
                            maxlength="10"
                            value={this.state.date}
                            onChange={this.handleOnChange}
                        />
                        <ArticleInputFormGroup
                            label="제목"
                            type="text"
                            name="title"
                            value={this.state.title}
                            onChange={this.handleOnChange}
                        />
                        <ArticleInputFormGroup
                            label="소제목"
                            type="text"
                            name="subTitle"
                            value={this.state.subTitle}
                            onChange={this.handleOnChange}
                        />
                        <QuillEditor 
                            articleId={this.props.id}
                            id={this.props.id}
                            imageCount={this.state.imageCount}
                            setImageCount={this.setImageCount}
                            label="내용"
                            name="text"
                            value={this.state.text}
                            onChange={this.handleQuillChange}
                        />
                        <Row>
                            <Col md={{offset : 10}}>
                                <Button
                                    color={canRegister ? "primary" : "warning"}
                                    onClick={() => {
                                        const {category, title, subTitle, text, imageCount, date} = this.state;
                                        this.props.onAddNewArticle({
                                            id : this.props.id, 
                                            category,
                                            title, 
                                            subTitle, 
                                            text, 
                                            date,
                                            imageCount
                                        });
                                        this.setImageCount(0);
                                        this.toggleCollapse();
                                    }}
                                    disabled={!canRegister}
                                    size="sm"
                                    outline
                                >
                                    등록
                                </Button>
                                <Button
                                    color="danger"
                                    onClick={() => {
                                        this.toggleCollapse();
                                        this.setImageCount(0);
                                        this.props.onDeleteAddedNewArticle(this.props.id, this.state.imageCount);
                                    }}
                                    size="sm"
                                    outline
                                >
                                    등록취소
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Collapse>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        id : state.admin.homepage.newArticleId
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onStartAddNewArticle : () => {
            dispatch(homepageActions.startAddNewArticle());
        },
        onDeleteAddedNewArticle : (id, imageCount) => {
            dispatch(homepageActions.deleteAddedNewArticle(id, imageCount));
        },
        onAddNewArticle : (datas) => {
            dispatch(homepageActions.addNewArticle(datas))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewArticle);


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/ArticleManager/NewArticle.js